var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "head-container" },
        [
          _c("eHeader", {
            attrs: { dict: _vm.dict, permission: _vm.permission },
          }),
          _vm._v(" "),
          _c("crudOperation", { attrs: { permission: _vm.permission } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.crud.loading,
              expression: "crud.loading",
            },
          ],
          ref: "table",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.crud.data },
          on: { "selection-change": _vm.crud.selectionChangeHandler },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "name", label: "名称" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "jobSort", label: "排序" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(scope.row.jobSort) + "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "status", label: "状态", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#409EFF",
                        "inactive-color": "#F56C6C",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeEnabled(scope.row, scope.row.enabled)
                        },
                      },
                      model: {
                        value: scope.row.enabled,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "enabled", $$v)
                        },
                        expression: "scope.row.enabled",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "创建日期" },
          }),
          _vm._v(" "),
          _vm.checkPer(["admin", "job:edit", "job:del"])
            ? _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "130px",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("udOperation", {
                            attrs: {
                              data: scope.row,
                              permission: _vm.permission,
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  398919237
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination"),
      _vm._v(" "),
      _c("eForm", { attrs: { "job-status": _vm.dict.job_status } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }